"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.46 7.89c.947-2.223 3.11-3.14 4.94-2.77a.5.5 0 0 0 .2-.98c-2.02-.409-4.308.441-5.6 2.48-1.233-1.946-3.374-2.809-5.321-2.528a4.67 4.67 0 0 0-2.937 1.612C2.968 6.624 2.5 7.9 2.5 9.5c0 3.233 2.406 6.113 4.668 8.124a29 29 0 0 0 4.56 3.297l.02.012.007.003h.001s.001.001.244-.436l-.244.437a.5.5 0 0 0 .487 0L12 20.5l.243.437.002-.001.006-.003.021-.012.029-.016.05-.03q.104-.06.294-.173a29 29 0 0 0 4.187-3.078c2.262-2.011 4.668-4.89 4.668-8.124 0-.58-.062-1.12-.178-1.614a.5.5 0 1 0-.973.228c.097.415.151.876.151 1.386 0 2.766-2.094 5.387-4.332 7.376A28 28 0 0 1 12 19.922l-.128-.077a28 28 0 0 1-4.04-2.97C5.594 14.888 3.5 12.268 3.5 9.501c0-1.4.407-2.437 1.008-3.152A3.67 3.67 0 0 1 6.82 5.082c1.781-.257 3.81.675 4.719 2.808L12 8.97z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M20.366 5.84a.5.5 0 1 0-.732-.68l-6.147 6.62-1.633-1.634a.5.5 0 0 0-.708.708l2 2a.5.5 0 0 0 .72-.014z"
  })]
}), 'Health');
